import axios from "axios";

// Same backend the mobile app and admin panel talk to.
// Override for local work with REACT_APP_API_URL=http://localhost:5002/api
export const API_BASE =
  // "http://localhost:5002/api" ||
  "https://narayanhomefacilityservices.com/api";

// Deliberately NOT 'nry_token' — that key belongs to the admin panel. Keeping
// them separate means a customer session and an admin session can coexist on
// the same origin without silently clobbering each other.
export const TOKEN_KEY = "nry_web_token";
export const USER_KEY = "nry_web_user";

const http = axios.create({ baseURL: API_BASE });

let authToken = null;

export const setToken = (t) => {
  authToken = t;
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    /* private mode / storage disabled — the in-memory token still works */
  }
};

export const getToken = () => {
  if (authToken) return authToken;
  try {
    authToken = localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    authToken = null;
  }
  return authToken;
};

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// The API answers { success, message, data }. The mobile client unwraps to
// `data` and throws on failure — web does exactly the same so every screen
// ported from the app reads identically.
function unwrap(res) {
  const json = res?.data;
  if (json && json.success === false)
    throw new Error(json.message || "Request failed");
  return json?.data !== undefined ? json.data : json;
}

function toError(err) {
  if (err?.response?.status === 401) {
    setToken(null);
    try {
      localStorage.removeItem(USER_KEY);
    } catch (e) {
      /* ignore */
    }
    // Let the app know so it can bounce to the login screen.
    window.dispatchEvent(new CustomEvent("nry:unauthorized"));
  }
  const message =
    err?.response?.data?.message ||
    (err?.code === "ERR_NETWORK"
      ? "Network error — please check your connection."
      : err?.message) ||
    "Request failed";
  return new Error(message);
}

async function request(method, path, body) {
  try {
    const res = await http.request({ method, url: path, data: body });
    return unwrap(res);
  } catch (err) {
    throw toError(err);
  }
}

export const api = {
  get: (p) => request("get", p),
  post: (p, body) => request("post", p, body),
  put: (p, body) => request("put", p, body),
  del: (p) => request("delete", p),
};

export default api;
